import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { useCredits } from '../../hooks/useCredits';
import { Link } from 'react-router-dom';

interface AppLayoutProps {
  children: ReactNode;
}

export const AppLayout = ({ children }: AppLayoutProps) => {
  const { credits } = useCredits();

  return (
    <div className="min-h-screen flex flex-col bg-[#0A0E27]">
      <Header />
      <div className="mt-20 flex-1">
        <div className="container mx-auto px-6 py-8">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center space-x-4">
              <Link to="/dashboard" className="text-gray-400 hover:text-white transition">
                Dashboard
              </Link>
              <span className="text-gray-600">/</span>
              <Link to="/dashboard/history" className="text-gray-400 hover:text-white transition">
                Histórico
              </Link>
            </div>
            <Link
              to="/dashboard/credits"
              className="card-dark px-4 py-2 hover:border-[#3B82F6] transition"
            >
              <span className="text-sm text-gray-400">Créditos: </span>
              <span className="font-semibold text-white">{credits}</span>
            </Link>
          </div>
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
};

